import React, { useMemo } from 'react';
import { Checkbox } from './checkbox';
import { List } from './list';
import { ListOption } from './list-item';
import { StyleProp, StyleSheet, Text, TextStyle } from 'react-native';

export interface CheckBoxActionSheetOptions<T> {
  label: string;
  value: T;
}

interface Props<T> {
  onSelect: (option: string) => void;
  options: CheckBoxActionSheetOptions<T>[];
  selectedOptions: Set<string>;
  title: string;
  titleStyle?: StyleProp<TextStyle>;
}

export const CheckboxGroup = <T extends string = string>({
  onSelect,
  options,
  selectedOptions,
  title,
  titleStyle,
}: Props<T>) => {
  const listOptions = useMemo<ListOption[]>(() => {
    const result: ListOption[] = [];
    options.forEach((option) => {
      result.push({
        title: option.label,
        value: option.value,
      });
    });
    return result;
  }, [options]);

  return (
    <>
      <Text style={titleStyle}>{title}</Text>
      <List
        data={listOptions}
        onSelect={(option) => {
          onSelect(option.value as string);
        }}
        renderLeftComponent={(option) => (
          <Checkbox
            isSelected={selectedOptions.has(option.value as string) || false}
            onSelect={() => {
              onSelect(option.value as string);
            }}
            style={styles.checkbox}
            trackingData={{
              name: `checkbox_group.${title}.${option.title}`,
            }}
          />
        )}
      />
    </>
  );
};

const styles = StyleSheet.create({
  checkbox: {
    paddingHorizontal: 0,
    paddingVertical: 0,
  },
});
